import TaskImage from "../../../../../../assets/icons/tasks.svg";
import MeetingImage from "../../../../../../assets/icons/meetings.svg";
import CallsImage from "../../../../../../assets/icons/phone.svg";
import { formatDate, formatDateTime } from "../../../../../../utils/utils";
export const TAB_OPTIONS = [
    { label: "Tasks", icon: TaskImage, countKey: "tasksCount" },
    { label: "Meetings", icon: MeetingImage, countKey: "meetingsCount" },
    { label: "Calls", icon: CallsImage, countKey: "callsCount" },
  ];
  export const taskColumns = [
    {
      key: "subject",
      label: "Subject",
      render: (task: any) => task.subject,
    },
    {
      key: "due_date",
      label: "Due Date",
      render: (task: any) => formatDate(task.due_date),
    },
    {
      key: "owner",
      label: "Owner",
      render: (task: any) =>
        task.owner ? `${task.owner.first_name} ${task.owner.last_name}` : "-",
    },
    {
      key: "status",
      label: "Status",
      render: (task: any) => task.status,
    },
    {
      key: "priority",
      label: "Priority",
      render: (task: any) => task.priority,
    },
  ];
  export const completedTaskColumns = [
    {
      key: "subject",
      label: "Subject",
      render: (task: any) => task.subject,
    },
    {
      key: "due_date",
      label: "Due Date",
      render: (task: any) => (task.due_date ? formatDate(task.due_date) : "-"),
    },
    {
      key: "owner",
      label: "Owner",
      render: (task: any) =>
        task.owner ? `${task.owner.first_name} ${task.owner.last_name}` : "-",
    },
    {
      key: "priority",
      label: "Priority",
      render: (task: any) => task.priority,
    },
    {
      key: "closedTime",
      label: "Closed Time",
      render: (task: any) => formatDateTime(task.closed_time) || "-",
    },
  ];
  